import { render, staticRenderFns } from "./RealEstateEvaluationEdit.vue?vue&type=template&id=20483620&scoped=true&"
import script from "./RealEstateEvaluationEdit.vue?vue&type=script&lang=js&"
export * from "./RealEstateEvaluationEdit.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateEvaluationEdit.vue?vue&type=style&index=0&id=20483620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20483620",
  null
  
)

export default component.exports